module controllers {
    export module master {
        interface IPermitSLAScope extends ng.IScope {
        }
        interface IPermitSLAParams extends ng.ui.IStateParamsService {
        }

        export class permitSLACtrl {
            static $inject = ["$scope", '$rootScope', 'generalService', '$q', '$anchorScroll', 'bsLoadingOverlayService', '$state', '$timeout', "$stateParams",
                "permitSLAService", "permitService", "entityService","classificationValueService",'consigneeService','transportModeService',"unLocationCodeService", 'incotermService',
                "termsOfDeliveryService",
                 'prohibitedAndRestrictedService',
                 '$uibModal'
            ];

            permitSLAList: Array<interfaces.master.IPermitSLA> = [];
            apiPermitSLAList: uiGrid.IGridApi;
            currentEntity: interfaces.applicationcore.IDropdownModel;
            entity: interfaces.applicationcore.IDropdownModel;
            entityId: number = undefined;
            IsLoading: boolean = true;
            showAll: boolean = true;
            IsSetRowInactive: boolean = false;

            curentEntityId:number;

            constructor(private $scope: IPermitSLAScope,
                private $rootScope: interfaces.applicationcore.IRootScope,
                private generalService: interfaces.applicationcore.IGeneralService,
                private $q: ng.IQService,
                private $anchorScroll: ng.IAnchorScrollService,
                private bsLoadingOverlayService: interfaces.applicationcore.IbsLoadingOverlayService,
                private $state: ng.ui.IStateService,
                private $timeout: ng.ITimeoutService,
                private $stateParams: IPermitSLAParams,
                private permitSLAService: interfaces.master.IPermitSLAService,
                private permitService: interfaces.master.IPermitService,
                private entityService: interfaces.applicationcore.IEntityService,
                private classificationValueService: interfaces.applicationcore.IClassificationValueService,
                public consigneeService: services.master.consigneeService,
                public transportModeService: services.applicationcore.transportModeService,
                public unLocationCodeService: interfaces.applicationcore.IUNLocationCodeService,
                public incotermService: services.applicationcore.incotermService,
                public termsOfDeliveryService: interfaces.master.ITermsOfDeliveryService,
                private prohibitedAndRestrictedService: interfaces.tariff.IProhibitedAndRestrictedService,
                private $uibModal: ng.ui.bootstrap.IModalService,
            ) {
                this.getCurrentEntity();
                this.loadPermitSLAs();
            }

            loadPermitSLAs() {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'permit.sla'
                }, () => {
                    return this.permitSLAService.getList().query({
                    }, (result: Array<interfaces.master.IPermitSLA>) => {
                        this.permitSLAList = result;                       
                        this.$timeout(() => {
                            this.gvwPermitSLAList.data = result;
                        });
                          this.IsLoading = false;
                    }, (errorResponse) => {
                          this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                          this.IsLoading = false;
                    }).$promise;
                });
            }

            getCurrentEntity() {
                return this.entityService.getCurrentEntity().query((result: interfaces.applicationcore.IEntity) => {
                    this.curentEntityId = result.Id;
                    this.currentEntity  =  <interfaces.applicationcore.IDropdownModel> {Id: result.Id,Code: result.Code,Description: result.Name,Display:result.Code +  ' - ' + result.Name};
                }, (failureData) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                }).$promise;
            }

            loadFlowList() {
                return this.classificationValueService.GetClassificationValueDropdownByClassification().query({
                    classificationId: Enum.ClassificationEnum.FlowType
                }, () => {
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }



            loadEntities(searchText: string) {
                return this.entityService.getDropdownList(searchText).query(() => {
                }, (errorResponse) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                }).$promise;
            };

            loadRestrictions(countryId:number) {
                return this.permitService.getRestrictionsDropdown().query({
                    countryId: countryId
                }, () => {
                }, (failureData) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                }).$promise;
            }            

            /*
            loadRestrictions(searchText:string, countryId:number){
                return this.prohibitedAndRestrictedService.getForDropDown(searchText,countryId).query(()=>{
                }, (errorResponse) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                }).$promise;
            }*/

            loadCheckRestrictionCountries(searchText, entityId:number){
                return this.prohibitedAndRestrictedService.getCheckRestrictionCountriesForDropDown(searchText,entityId).query(()=>{
                }, (errorResponse) => {
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                }).$promise;
            }

            addNewPermitSLA() {
                var add = <interfaces.master.IPermitSLA>{
                    Entity : this.currentEntity,
                    IsActive: true,
                };
                (<Array<any>>(this.gvwPermitSLAList.data)).splice(0, 0, add);
            };

            removeInlinePermitSLA(entity: interfaces.master.IPermitSLA) {
                if (entity.Id > 0)
                {
                    entity.IsActive = false;
                    this.apiPermitSLAList.rowEdit.setRowsDirty([entity]);
                    this.IsSetRowInactive = true;
                    this.submitPermitSLAs()
                }
                else
                {
                    _.remove(this.gvwPermitSLAList.data, (o) => {
                        return o === entity;
                    });
                }
            }

            registerPermitSLAGridApi(gridApi: uiGrid.IGridApi) {
                this.apiPermitSLAList = gridApi;

                this.apiPermitSLAList.cellNav.on.navigate(this.$scope, (gridSelection) => {
                    this.apiPermitSLAList.selection.selectRow(gridSelection.row.entity);
                });

                this.$timeout(() => {
                    this.gvwPermitSLAList.data = this.permitSLAList;
                });
            };


            showEmailList(entity: interfaces.master.IPermitSLA) {
                this.displayEmails(entity.Emails)
                    .then((result) => {                  
                        entity.Emails = result;
                        this.apiPermitSLAList.rowEdit.setRowsDirty([entity]);
                    })
                    .catch(() => {
                        console.log('Modal cancelled');
                    })
                    .finally(() => {
                        console.log('Modal closed');
                    });
            }

            displayEmails(Emails: string) {
                return this.$uibModal.open({
                    animation: true,
                    template: `
                        <div class="modal-content" >
                            <form name="permitEmailList">
                                <div class="gts-padding">
                                    <fieldset id="permitEmailList">
                                    <legend>
                                        Add/Update Email List
                                    </legend>                                            
                                            <div class="row vertical-align">
                                                <div class="col-md-12">
                                                    <p class="input-group-sm has-feedback" ng-class="{'has-error': emailList.$invalid}">
                                                         <textarea id="emailList" class="form-control" ng-model="Emails" rows="25"></textarea>
                                                    </p>
                                                </div>                                               
                                            </div>                                            
                                            <div class="gts-padding pull-right">                                               
                                                    <button type="button" class="btn btn-primary" ng-disabled="permitEmailList.$invalid" ng-click="ok()">Ok</button>
                                                    <button type="button" class="btn btn-info" ng-click="cancel()">Cancel</button>
                                            </div>                                       
                                    </fieldset>
                                </div>
                            </form>
                        </div>
                    `
                    ,
                    controller: ($scope, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService) => {
                        $scope.Emails = Emails;
                       
                        $scope.cancel = () => {
                            $uibModalInstance.dismiss();
                        }

                        $scope.ok = () => {
                            $uibModalInstance.close($scope.Emails);
                        };
                    },
                    controllerAs: "permitEmailListCtrl",
                    size: "md",
                    resolve: {
                    }
                }).result;
            }            


            gvwPermitSLAList: uiGrid.IGridOptions | any = {
                data: <Array<interfaces.master.IPermitSLA>>[],
                enableFiltering: true,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                cellEditableCondition: true,
                paginationPageSizes: [25, 50, 100],
                paginationPageSize: 25,
                showGridFooter: true,
                onRegisterApi: (gridApi) => { this.registerPermitSLAGridApi(gridApi); },
                gridMenuShowHideColumns: false,
                enableGridMenu: true,
                exporterMenuCsv: false,
                exporterMenuPdf: false,
                exporterMenuExcel: true,
                exporterExcelFilename: 'PermitSLAList.xlsx',
                exporterFieldCallback: (grid, row, col, value) => {
                    return this.generalService.handleValue(value);
                },
                exporterSuppressColumns: ['ADD', 'NUMRECS'],
                columnDefs: [ 
                    {
                        name: "ADD",
                        displayName: "",
                        field: "",
                        
                        enableSorting: false,
                        enableColumnMenu: false,
                        enableCellEditOnFocus: false,
                        width: 55,
                        cellTemplate: `
                        <div class="GridButton"> 
                            <button type="button" ng-click="grid.appScope.permitSLACtrl.removeInlinePermitSLA(row.entity)" class="btn btn-warning btn-sm">
                                Delete
                            </button>
                        </div>`,                        
                        headerCellTemplate: `
                            <div class="GridButton">
                                <button type="button"  class="btn btn-default btn-sm" ng-click="grid.appScope.permitSLACtrl.addNewPermitSLA()">
                                    <span class="fa fa-plus"></span>
                                </button>
                            </div>`
                    },
                    {
                        name: "ENTITY",
                        displayName: "* Entity",
                        field: "Entity",
                        enableCellEditOnFocus: true,
                        enableCellEdit: true,
                        width: 120,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD.Display}}">{{MODEL_COL_FIELD.Display}}</div>`,
                        editableCellTemplate: `
                                    <form name="inputForm">
                                        <gts-dropdown ui-select-wrap name="{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm"
                                        ng-change="grid.appScope.permitSLACtrl.makeRowDirty(row)"
                                        load-data="grid.appScope.permitSLACtrl.loadEntities(searchText)" pagination-search="true" refresh-delay="1000"                                       
                                        ></gts-dropdown>
                                    </form>`,
                        filterHeaderTemplate: `
                                <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                    <div class="input-group-sm">
                                        <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                    </div>
                                </div>`,
                        filter: {
                            condition: (searchTerm, cellValue) => {
    
                                if (cellValue) {
                                    return (cellValue.Display.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0 || searchTerm.length === 0);
                                }
                                return null;
                            }
                        },
                        sortingAlgorithm: (a, b, rowA, rowB, direction) => {
                            var nulls = this.apiPermitSLAList.core.sortHandleNulls(a, b);
                            if (nulls !== null) {
                                return nulls;
                            } else {
                                if (a === b) {
                                    return 0;
                                }
    
                                if (direction === "desc") {
                                    if (a.Display < b.Display) return -1;
                                    if (a.Display > b.Display) return 1;
                                } else if (direction === "asc") {
                                    if (a.Display > b.Display) return 1;
                                    if (a.Display < b.Display) return -1;
                                }
    
                                return 0;
                            }
                        },
                    },
                  {
                        name: "Country",
                        displayName: "* Country",
                        field: "Country",
                        enableCellEditOnFocus: true,
                        enableCellEdit: true,
                        width: 200,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD.Display}}">{{MODEL_COL_FIELD.Display}}</div>`,
                        editableCellTemplate: `
                                    <form name="inputForm">
                                        <gts-dropdown ui-select-wrap name="{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.permitSLACtrl.loadCheckRestrictionCountries(searchText,row.entity.Entity.Id)" pagination-search="true" refresh-delay="1000"
                                        ng-change="grid.appScope.permitSLACtrl.makeRowDirty(row)" 
                                        ></gts-dropdown>
                                    </form>`,
                        filterHeaderTemplate: `
                                <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                    <div class="input-group-sm">
                                        <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                    </div>
                                </div>`,
                        filter: {
                            condition: (searchTerm, cellValue) => {
    
                                if (cellValue) {
                                    return (cellValue.Display.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0 || searchTerm.length === 0);
                                }
                                return null;
                            }
                        },
                        sortingAlgorithm: (a, b, rowA, rowB, direction) => {
                            var nulls = this.apiPermitSLAList.core.sortHandleNulls(a, b);
                            if (nulls !== null) {
                                return nulls;
                            } else {
                                if (a === b) {
                                    return 0;
                                }
    
                                if (direction === "desc") {
                                    if (a.Display < b.Display) return -1;
                                    if (a.Display > b.Display) return 1;
                                } else if (direction === "asc") {
                                    if (a.Display > b.Display) return 1;
                                    if (a.Display < b.Display) return -1;
                                }
    
                                return 0;
                            }
                        },
                    },                    
                    {
                        name: "Type",
                        displayName: "Type",
                        field: "FlowType",
                        enableCellEditOnFocus: true,
                        enableCellEdit: true,
                        width: 200,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD.Display}}">{{MODEL_COL_FIELD.Display}}</div>`,
                        editableCellTemplate: `
                                    <form name="inputForm">
                                        <gts-dropdown ui-select-wrap name="{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.permitSLACtrl.loadFlowList()" pagination-search="true" refresh-delay="1000"
                                        ng-change="grid.appScope.permitSLACtrl.makeRowDirty(row)" 
                                        ></gts-dropdown>
                                    </form>`,
                        filterHeaderTemplate: `
                                <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                    <div class="input-group-sm">
                                        <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                    </div>
                                </div>`,
                        filter: {
                            condition: (searchTerm, cellValue) => {
    
                                if (cellValue) {
                                    return (cellValue.Display.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0 || searchTerm.length === 0);
                                }
                                return null;
                            }
                        },
                        sortingAlgorithm: (a, b, rowA, rowB, direction) => {
                            var nulls = this.apiPermitSLAList.core.sortHandleNulls(a, b);
                            if (nulls !== null) {
                                return nulls;
                            } else {
                                if (a === b) {
                                    return 0;
                                }
    
                                if (direction === "desc") {
                                    if (a.Display < b.Display) return -1;
                                    if (a.Display > b.Display) return 1;
                                } else if (direction === "asc") {
                                    if (a.Display > b.Display) return 1;
                                    if (a.Display < b.Display) return -1;
                                }
    
                                return 0;
                            }
                        },
                    },
                      
                    {
                        name: "Restriction",
                        displayName: "Restriction",
                        field: "Restriction",
                        enableCellEditOnFocus: true,
                        enableCellEdit: true,
                        width: 340,
                        cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD.Display}}">{{MODEL_COL_FIELD.Display}}</div>`,
                        editableCellTemplate: `
                                    <form name="inputForm">
                                        <gts-dropdown ui-select-wrap name="{{MODEL_COL_FIELD.$$hashKey}}" append-to-body="true" ng-model="MODEL_COL_FIELD" form="inputForm" load-data="grid.appScope.permitSLACtrl.loadRestrictions(row.entity.Country.Id)" pagination-search="true" refresh-delay="1000"
                                        ng-change="grid.appScope.restrictionOptOutCtrl.makeRowDirty(row)"
                                        ></gts-dropdown>
                                    </form>`,
                        filterHeaderTemplate: `
                                <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                    <div class="input-group-sm">
                                        <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                    </div>
                                </div>`,
                        filter: {
                            condition: (searchTerm, cellValue) => {
    
                                if (cellValue) {
                                    return (cellValue.Display.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) >= 0 || searchTerm.length === 0);
                                }
                                return null;
                            }
                        },
                        sortingAlgorithm: (a, b, rowA, rowB, direction) => {
                            var nulls = this.apiPermitSLAList.core.sortHandleNulls(a, b);
                            if (nulls !== null) {
                                return nulls;
                            } else {
                                if (a === b) {
                                    return 0;
                                }
    
                                if (direction === "desc") {
                                    if (a.Display < b.Display) return -1;
                                    if (a.Display > b.Display) return 1;
                                } else if (direction === "asc") {
                                    if (a.Display > b.Display) return 1;
                                    if (a.Display < b.Display) return -1;
                                }
    
                                return 0;
                            }
                        },
                    }                    
                    ,
                    {
                        name: "Emails",
                        displayName: "* Email List",
                        field: "Emails",
                        width: 200,
                        enableCellEdit: true,
                        enableCellEditOnFocus: true,
                        cellEditableCondition: true,
                        filterHeaderTemplate: `
                        <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                            <div class="input-group-sm">
                                <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                            </div>
                        </div>`,
                       
           cellTemplate: `  
    <div class="ui-grid-cell-contents">
        <span>{{MODEL_COL_FIELD.split(',')[0].trim()}}</span>
        <button type="button" 
                class="btn btn-xs btn-info" 
                ng-if="MODEL_COL_FIELD"
                ng-click="grid.appScope.permitSLACtrl.showEmailList(row.entity)" 
                title="View all emails">                                
            <span class="fa fa-eye"></span>
            <span ng-if="MODEL_COL_FIELD.split(',').length > 1">
                (+{{MODEL_COL_FIELD.split(',').length - 1}} more)
            </span>
        </button>
    </div>
`,
                        editableCellTemplate: `

                            <div ng-if="MODEL_COL_FIELD" class="ui-grid-cell-contents">
                                <span>{{MODEL_COL_FIELD.split(',')[0].trim()}}</span>
                                <button type="button" 
                                        class="btn btn-xs btn-info" 
                                        ng-if="MODEL_COL_FIELD"
                                        ng-click="grid.appScope.permitSLACtrl.showEmailList(row.entity)" 
                                        title="View all emails">                                
                                    <span class="fa fa-eye"></span>
                                    <span ng-if="MODEL_COL_FIELD.split(',').length > 1">
                                        (+{{MODEL_COL_FIELD.split(',').length - 1}} more)
                                    </span>
                                </button>
                            </div>
                            
                   
                                <button ng-if="!MODEL_COL_FIELD" type="button" 
                                        class="btn btn-xs btn-info" 
                                        
                                        ng-click="grid.appScope.permitSLACtrl.showEmailList(row.entity)" 
                                        title="View all emails">                                
                                    Add Emails
                                    <span ng-if="MODEL_COL_FIELD.split(',').length > 1">
                                        (+{{MODEL_COL_FIELD.split(',').length - 1}} more)
                                    </span>
                                </button>                               
                                
                            `,
                    },
                    {
                        name: "ValidityDays",
                        displayName: "* Validity Days",
                        field: "ValidityDays",
                        width: 175,
                        enableCellEdit: true,
                        enableCellEditOnFocus: true,
                        cellEditableCondition: true,
                        filterHeaderTemplate: `
                        <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                            <div class="input-group-sm">
                                <input type="text" class="form-control" 
                                ng-model="colFilter.term" 
                                ng-model-options="{ debounce: 1000 }"/>
                            </div>
                        </div>`,                       
                        cellTemplate: `
                        <div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD | number : 0}}">{{MODEL_COL_FIELD | number : 0}}
                        </div>
                        `,
                        editableCellTemplate: `
                            <form name = "inputForm">
                                <p class="input-group-sm">
                                <input 
                                    type="number" 
                                    name="ValidityDays-{{MODEL_COL_FIELD.$$hashKey}}" 
                                    ng-model="MODEL_COL_FIELD" 
                                    ng-change="grid.appScope.restrictionOptOutCtrl.makeRowDirty(row)"
                                    class="form-control" 
                                    ui-grid-editor                                   
                                    ng-pattern="/^[0-9]+$/" 
                                    />
                                </p>
                            </form>`,
                    },  
                    {
                        name: "QuotaPercentage",
                        displayName: "Quota %",
                        field: "QuotaPercentage",
                        width: 175,
                        enableCellEdit: true,
                        enableCellEditOnFocus: true,
                        cellEditableCondition: true,
                        filterHeaderTemplate: `
                        <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                            <div class="input-group-sm">
                                <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                            </div>
                        </div>`,                       
                        cellTemplate: `
                        <div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD | number : 2}}">{{MODEL_COL_FIELD | number : 2}}
                        </div>
                        `,
                        editableCellTemplate: `
                            <form name = "inputForm">
                                <p class="input-group-sm">
                                <input 
                                    type="number" 
                                    name="QuotaPercentage-{{MODEL_COL_FIELD.$$hashKey}}" 
                                    ng-model="MODEL_COL_FIELD" 
                                    ng-change="grid.appScope.restrictionOptOutCtrl.makeRowDirty(row)"
                                    class="form-control" 
                                    ui-grid-editor                                                   
                                    step="0.01"
                                    min="0.01"
                                    max="99.99"
                                    ng-pattern="/^(?:[1-9][0-9]?(?:\.[0-9]{1,2})?|0\.[0-9]{1,2})$/"
                                    />
                                </p>
                            </form>`,
                    },                                       
                {
                    name: "ACTIVE",
                    displayName: "* Active",
                    field: "IsActive",
                    width: 70,
                    cellTemplate: `<center><input type="checkbox" ng-change="grid.appScope.permitSLACtrl.makeRowDirty(row)" ng-model="row.entity.IsActive"></center>`,
                    editableCellTemplate: ` 
                            <form name="inputForm">
                                <p class="input-group-sm">
                                    <input type="checkbox" ng-model="row.entity.IsActive">
                                </p>
                            </form>`,
                    enableCellEdit: true,
                    enableCellEditOnFocus: true,
                    cellEditableCondition: true,
                }, {
                    name: "INFO",
                    displayName: "",
                    field: "",
                    cellTemplate: `
                        <div class="GridButton"> 
                            <gts-stamp-info createstampfullname="row.entity.CreateStampFullName" createstampdate="row.entity.CreateStampDate"
                                updatestampfullname="row.entity.UpdateStampFullName" updatestampdate="row.entity.UpdateStampDate">
                            </gts-stamp-info>
                        </div>`,
                    width: 45,
                    enableSorting: false,
                },
             ]
            };

            makeRowDirty(row: uiGrid.IGridRow) {
                this.apiPermitSLAList.rowEdit.setRowsDirty([row.entity]);
            }

            entityChange(model: interfaces.applicationcore.IDropdownModel) {
                this.entity = model;

                if (model)
                    this.entityId = model.Id;
                else
                    this.entityId = undefined;
            }

            downloadToExcel() {
                this.IsLoading = true;


                this.permitSLAService.getPermitSLAExcel().then(() => {
                    this.IsLoading = false;
                }, (data) => {
                    this.IsLoading = false;
                    //this.gvwList.data = [];
                    //this.gvwList.totalItems = 0;
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>data.data);
                });
            }            
                      
            
            //Submit
            submitPermitSLAs() {
                //Get dirty products.
                var permitSLAList: Array<interfaces.master.IPermitSLA> = [];
                if (this.apiPermitSLAList && this.apiPermitSLAList.rowEdit.getDirtyRows().length > 0) {
                    permitSLAList = _.map(this.apiPermitSLAList.rowEdit.getDirtyRows(), (o) => {
                        return o.entity;
                    });
                }

                this.bsLoadingOverlayService.wrap({
                    referenceId: 'permit.sla'
                }, () => {
                    //Save Dirty Products
                    return this.permitSLAService.savePermitSLAs().save(permitSLAList, (data: interfaces.applicationcore.IMessageHandler) => {
                        this.generalService.displayMessageHandler(data);

                        this.$timeout(() => {
                            if (this.apiPermitSLAList && !data.HasErrorMessage) {
                                this.apiPermitSLAList.rowEdit.setRowsClean(permitSLAList);
                                this.loadPermitSLAs();

                                if (this.IsSetRowInactive){
                                    this.generalService.displayMessage("Restriction Opt Out set to inactive.", Enum.EnumMessageType.Success);
                                    this.IsSetRowInactive = false;
                                }                            
                            }
                        });
                    }, (errorResponse) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                    }).$promise;
                });
            };

            Close() {
                this.entity = undefined;
                this.entityId = undefined;
                this.$anchorScroll("topAnchor");
                this.$state.go("^");
            }
        }

        angular.module("app").controller("permitSLACtrl", controllers.master.permitSLACtrl);
    }
}